var $ = jQuery;
$(document).ready(function () {
  setTimeout(function () {
    $(".jdgm-widget .jdgm-prev-badge__stars").attr("role", "img");
    $("b.jdgm-rev__title").replaceWith(function () {
      return $("<strong />", {
        html: $(this).html(),
        class: $(this).attr("class"),
      });
    });
  }, 1000);
  console.log("ready");
});

function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

const debouncedOnDomChange = debounce(function () {
  $(
    ".slideshow__slide[aria-hidden], .testimonials-slide[aria-hidden], .product-main-slide[aria-hidden], .grid.grid--uniform[aria-hidden]"
  ).removeAttr("aria-hidden");
  $(".additional-checkout-buttons").each(function () {
    var ulElement = $(this).find("ul");

    if (ulElement.length > 0 && ulElement.children().length === 0) {
      ulElement.remove();
    }
  });
}, 500);
const observer = new MutationObserver((mutations) => {
  debouncedOnDomChange();
});
// Configuration of the observer
const config = {
  childList: true, // Observe direct children
  subtree: true, // and lower descendants
  attributes: true, // Observe attribute changes
};
// Start observing the document body (or any specific element)
observer.observe(document.body, config);

$(window).on("load", function () {
  setTimeout(function () {
    var i = 1;
    $("#web-pixels-manager-sandbox-container iframe").each(function () {
      $(this).attr("title", "web pixels iframe" + " " + i);
      i++;
    });
  }, 2000);

  console.log("load");
});
